module.exports = __webpack_public_path__ + "img/weingutloewenstein_4.9049304f.jpg";